import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'
import DtoStoreUtils from './dto-store.util'
import { dtoFeatureKey, DtoState, dtoStateAdapter, DtoWrapper, LoadingState } from './dto.state'

export const selectDtoState = createFeatureSelector<DtoState>(dtoFeatureKey)

const { selectIds, selectEntities, selectAll, selectTotal } = dtoStateAdapter.getSelectors()

export const selectDtoIds = createSelector(selectDtoState, selectIds)

export const selectDtoIdsAsString = createSelector(
  selectDtoIds,
  (ids: string[] | number[]) => <Array<string>>(<unknown>ids)
)

export const selectDtoEntities = createSelector(selectDtoState, selectEntities)

export const selectAllDTOs = createSelector(selectDtoState, selectAll)

// is that needed at all?
export const selectDtoCount = createSelector(selectDtoState, selectTotal)

export const selectDtoWithTypeAndId = createSelector(
  selectDtoEntities,
  (dtoEntities: Dictionary<DtoWrapper>, props: any) =>
    dtoEntities[DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id)]
)

export const selectDtoWithStoreId = createSelector(
  selectDtoEntities,
  (dtoEntities: Dictionary<DtoWrapper>, props: any) => dtoEntities[props.storeId]
)

export const selectDTOsWithStoreIds = createSelector(
  selectAllDTOs,
  (dtoWrappers: DtoWrapper[], props: { storeIds: string[] }) =>
    dtoWrappers.filter((dw) => props.storeIds.some((storeId) => storeId === dw.dtoKey))
)

export const selectDTOsWithTypeAndIds = createSelector(
  selectAllDTOs,
  (dtoWrappers: DtoWrapper[], props: { type: string; ids: number[] }) =>
    dtoWrappers.filter((dw) =>
      props.ids.some((id) => DtoStoreUtils.getStoreIdFromTypeAndId(props.type, id) === dw.dtoKey)
    )
)
// {
//     const result = dtoWrappers.filter(dw =>
//         props.ids.some(id =>  DtoStoreUtils.getStoreIdFromTypeAndId(props.type, id) === dw.dtoKey));

// // console.log('[selectDTOsWithTypeAndIds]: ', result);
// return result;
// }
// );

/** selects entities that are actually initialized (so no not-initialized with pending states) */
export const selectDtoExistWithTypeAndId = createSelector(
  // selectDtoIds,
  // (ids: string[], props: any) => ids.some(id => id === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id)));
  selectAllDTOs,
  // (dtoWrappers: DtoWrapper[], props: {type: string, id: number}) => dtoWrappers.some(dw => dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id) && !dw.pending));
  (dtoWrappers: DtoWrapper[], props: { type: string; id: number; partialEntityIsSufficient?: boolean }) =>
    dtoWrappers.some(
      (dw) =>
        dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id) &&
        !!dw.dto &&
        (!!props.partialEntityIsSufficient || dw.loadingState === LoadingState.Full)
    )
)

/** selects entities that are actually initialized (so no not-initialized with pending states) */
export const selectDtoExistWithStoreId = createSelector(
  // selectDtoIds,
  // (ids: string[], props: any) => ids.some(id => id === props.storeId));
  selectAllDTOs,
  // (dtoWrappers: DtoWrapper[], props: {storeId: string}) => dtoWrappers.some(dw => dw.dtoKey === props.storeId && !dw.pending));
  (dtoWrappers: DtoWrapper[], props: { storeId: string }) =>
    dtoWrappers.some((dw) => dw.dtoKey === props.storeId && !!dw.dto)
)

export const selectDtoExistOrIsPendingWithTypeAndId = createSelector(
  selectAllDTOs,
  // (dtoWrappers: DtoWrapper[], props: {type: string, id: number}) => dtoWrappers.some(dw => dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id) && !dw.pending));
  (dtoWrappers: DtoWrapper[], props: { type: string; id: number; partialEntityIsSufficient?: boolean }) =>
    dtoWrappers.some(
      (dw) =>
        // key check
        dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id) &&
        // either partial entity is enough and dto exists
        ((!!props.partialEntityIsSufficient && !!dw.dto) ||
          // or entity is pending (pending implies full loaded state)
          dw.pending ||
          // or entity is fully loaded
          (dw.loadingState === LoadingState.Full && !!dw.dto))
    )
)
// selectDtoIds,
// (ids: string[]|number[], props: {type: string, id: number, partialEntityIsSufficient?: boolean}) =>
//     ids.some(id => id === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id)));
// {
//     const result = (<Array<string>>ids).some(id => id === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id));
//     console.log('[selectDtoExistOrIsPendingWithTypeAndId]: ', result);
//     return result;
// });

// export const selectDtoExistOrIsPendingWithTypeAndId = createSelector(
//     selectDtoIdsAsString,
//     (ids: string[], props: any) => {
//         const result = (<Array<string>>ids).some(id => id === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id));
//         console.log('[selectDtoExistOrIsPendingWithTypeAndId]: ', result);
//         return result;
//     });

// export const selectDtoExistOrIsPendingWithTypeAndId = createSelector(
//     selectAllDTOs,
//     (dtoWrappers: DtoWrapper[], props: {type: string, id: number}) =>
//     dtoWrappers.some(dw => dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id)));
//     // true);

export const selectDtoIsPendingWithTypeAndId = createSelector(
  // selectDtoIds,
  // (ids: string[], props: any) => ids.some(id => id === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id)));
  selectAllDTOs,
  (dtoWrappers: DtoWrapper[], props: { type: string; id: number }) =>
    dtoWrappers.some((dw) => dw.dtoKey === DtoStoreUtils.getStoreIdFromTypeAndId(props.type, props.id) && dw.pending)
)
